import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { ResendConfirmationDocument } from './resend-confirmation.generated';

export const useResendConfirmation = (
  options: ApiOptions<typeof ResendConfirmationDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(ResendConfirmationDocument, {
    ...useNotifications(ResendConfirmationDocument, {
      failure: (error) => error.message || t('api.users.resend_confirmation_error'),
      success: t('api.users.resend_confirmation_success'),
    }),
    ...options,
  });
};
